module.exports = __webpack_public_path__ + "media/images/default/shared/header/main-lg-46e02852bd26d1d311a9afbdd9fbe99b.jpg";